import { useGlobalStore } from "controller/store/globalStore";
import { useSetAtom } from "jotai";
import { useEffect } from "react";
import type { AccessSpecifier } from "shared/types";
import { setChatDefaultSendMode } from "../store";

const ACCESS_SPECIFIERS: AccessSpecifier[] = ["public", "private", "self"];

const toAccessSpecifier = (value: string | null | undefined): AccessSpecifier =>
  ACCESS_SPECIFIERS.find((mode) => mode === value) ?? "public";

export const useDefaultChatSendMode = () => {
  const replyMode = useGlobalStore(
    (state) => state.generalConfig?.defaultReplyMode,
  );
  const setDefaultMode = useSetAtom(setChatDefaultSendMode);

  const defaultMode = toAccessSpecifier(replyMode);

  useEffect(() => {
    setDefaultMode(defaultMode);
  }, [defaultMode, setDefaultMode]);
};
